import React, { useCallback, useEffect, useState } from "react";
import { Modal, Button, Col } from "react-bootstrap";
import { XLg } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { TransElement } from "../../../utils";

interface DeleteProjectModalProps {
  showModal: boolean;
  handleCloseModal: () => void;
  onDelete: () => void;
  title: string;
}

const DeleteProjectModal: React.FC<DeleteProjectModalProps> = ({
  showModal,
  handleCloseModal,
  onDelete,
  title,
}) => {
  const { t } = useTranslation();
  const [deleteText, setDeleteText] = useState<string>(
    t("projects.deleteConfirm")
  );

  const handleResize = useCallback(() => {
    const screenWidth = window.innerWidth;
    setDeleteText(
      screenWidth > 768
        ? t("projects.deleteConfirm")
        : t("profile.deleteAction")
    );
  }, [t]);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
  }, [handleResize]);

  return (
    <Modal
      show={showModal}
      onHide={handleCloseModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="d-flex align-items-center justify-content-between border-0">
        <Modal.Title className="fs-3">
          {t("projects.deleteProject")}
        </Modal.Title>

        <XLg
          size={24}
          role="button"
          onClick={handleCloseModal}
          className="ms-auto text-dark-gray"
        />
      </Modal.Header>
      <div className="d-flex justify-content-center p-md-3">
        <p
          className="fs-6 text-center mb-0 px-3 px-md-0 text-gray"
          style={{ maxWidth: "412px" }}
        >
          <TransElement
            i18nKey="modal.deleteProjectText"
            values={{ projectName: title }}
            components={{
              1: <span className="fw-bold text-dark" />,
            }}
          />
        </p>
      </div>
      <div className="modalMobileBtns d-flex align-items-center justify-content-between gx-md-2">
        <Col className="modalMobileBtn" md={5}>
          <Button
            variant="outline-dark"
            onClick={() => {
              handleCloseModal();
            }}
            className="w-100 fw-normal dark-hover fs-6"
          >
            {t("projects.deleteCancel")}
          </Button>
        </Col>
        <Col className="modalMobileBtn" md={5}>
          <Button
            variant="danger"
            className="w-100 text-white fs-6"
            onClick={() => {
              onDelete();
              handleCloseModal();
            }}
          >
            {deleteText}
          </Button>
        </Col>
      </div>
    </Modal>
  );
};

export default DeleteProjectModal;
